import { Modal as AntdModal, Button } from "antd";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { useModal } from "../context/ModalContext";
import { useEffect, useState } from "react";
import { useIsSmallScreen } from "../utils/useMediaQuery";

export default function Modal() {
    const isSmallScreen = useIsSmallScreen(992);
    const { modal, closeModal } = useModal();
    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        if (modal.open) {
            const savedState = localStorage.getItem('modal-fullscreen') === 'true';
            setIsFullScreen(savedState);
        }
    }, [modal.open])

    const toggleFullScreen = () => {
        const newState = !isFullScreen;
        setIsFullScreen(newState);
        localStorage.setItem('modal-fullscreen', newState);
    }

    // Dikeyde ortalanır (üstten %20 boşluk kaldırıldı). Yükseklik viewport'a göre sınırlı;
    // uzun içerik alta kadar dolar, kısa içerik ortalanır.
    const bodyMaxHeight = 'calc(100vh - 100px)';

    return (
        <div>
            {
                modal.open && (
                    <AntdModal
                        // openId her açılışta değişir → içerik taze mount olur (bayat component sorunu çözülür,
                        // eski setTimeout gecikmesine/boş-yanıp-sönmeye gerek kalmaz).
                        key={modal.openId}
                        destroyOnClose
                        centered={!isFullScreen && !isSmallScreen}
                        style={
                            isFullScreen
                                ? { top: 0, margin: 0, padding: 0, maxWidth: '100vw', height: '100vh' }
                                : (isSmallScreen ? { top: 10, margin: 10, maxWidth: 'calc(100% - 20px)' } : {})
                        }
                        width={isFullScreen ? '100%' : (isSmallScreen ? '100%' : (modal.width || window.innerWidth * 0.6))}
                        visible={modal.open}
                        title={
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: 24 }}>
                                <span>{modal.title}</span>
                                <Button
                                    type="text"
                                    icon={isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
                                    onClick={toggleFullScreen}
                                />
                            </div>
                        }
                        onCancel={closeModal}
                        onOk={false}
                        footer={false}
                        bodyStyle={
                            isFullScreen
                                ? { height: 'calc(100vh - 55px)', overflowY: 'auto' }
                                : { maxHeight: bodyMaxHeight, overflowY: 'auto' }
                        }
                    >
                        {modal.component}
                    </AntdModal>
                )
            }
            {
                modal?.modal2?.open && (
                    <AntdModal
                        key={`m2-${modal.openId}`}
                        destroyOnClose
                        style={{ marginTop: 24 }}
                        width={isSmallScreen ? '100%' : window.innerWidth * 0.5}
                        visible={modal.modal2.open}
                        title={modal.modal2.title}
                        onCancel={closeModal}
                        onOk={false}
                        footer={false}
                        bodyStyle={{ maxHeight: 'calc(85vh - 55px)', overflowY: 'auto' }}
                    >
                        {modal.modal2.component}
                    </AntdModal>
                )
            }
        </div>
    )
}
